/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniChatBubbleLeftRight = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-chat-bubble-left-right ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M3.50491 2.36515C5.30269 2.1243 7.13702 2 9 2C10.863 2 12.6973 2.1243 14.4951 2.36515C15.7418 2.53218 16.6741 3.4733 16.9298 4.6333C16.7425 4.59823 16.5501 4.57486 16.3531 4.5641C15.5739 4.52154 14.7894 4.5 14 4.5C13.2106 4.5 12.4261 4.52154 11.6469 4.5641C9.22913 4.69615 7.5 6.72739 7.5 8.99794V11.2377C7.5 12.6511 8.17008 13.9726 9.26042 14.8002L6.28033 17.7803C6.06583 17.9948 5.74324 18.059 5.46299 17.9429C5.18273 17.8268 5 17.5533 5 17.25V13.8073C4.49897 13.7588 4.00056 13.7013 3.50493 13.6349C2.0334 13.4377 1 12.1622 1 10.7211V5.27886C1 3.83785 2.03337 2.5623 3.50491 2.36515Z"
        fill="#7041F1"
      />
      <path
        className="path"
        d="M14 6C13.2379 6 12.4807 6.0208 11.7287 6.06187C10.1572 6.1477 9 7.47212 9 8.99794V11.2377C9 12.7565 10.1467 14.077 11.7102 14.1726C11.9238 14.1857 12.1379 14.1971 12.3524 14.2068C12.5526 14.216 12.7366 14.2973 12.8702 14.4309L15.2197 16.7803C15.4342 16.9948 15.7568 17.059 16.037 16.9429C16.3173 16.8268 16.5 16.5533 16.5 16.25V14.1795C17.9525 13.9847 19 12.7165 19 11.2648V8.99794C19 7.47212 17.8428 6.1477 16.2713 6.06187C15.5193 6.0208 14.7621 6 14 6Z"
        fill="#7041F1"
      />
    </svg>
  );
};
